import { AUTH_TOKEN, DISABLE_CASHBACK_JOIN_BANNER, DISABLE_SINGLE_ACCOUNT_BANNER } from '~/constants'

export const storeToken = (token: string) => {
  return window.localStorage.setItem(AUTH_TOKEN, token)
}

export const storeSessionToken = (token: string) => {
  return window.sessionStorage.setItem(AUTH_TOKEN, token)
}

export const getToken = () => {
  return window.localStorage.getItem(AUTH_TOKEN) || window.sessionStorage.getItem(AUTH_TOKEN)
}

export const removeToken = () => {
  window.sessionStorage.removeItem(AUTH_TOKEN)
  return window.localStorage.removeItem(AUTH_TOKEN)
}

export const storeCashbackBanner = () => {
  return window.localStorage.setItem(DISABLE_CASHBACK_JOIN_BANNER, 'true')
}

export const getCashbackBanner = () => {
  return window.localStorage.getItem(DISABLE_CASHBACK_JOIN_BANNER)
}

export const storeSingleAccountBanner = () => {
  return window.localStorage.setItem(DISABLE_SINGLE_ACCOUNT_BANNER, 'true')
}

export const getSingleAccountBanner = () => {
  return window.localStorage.getItem(DISABLE_SINGLE_ACCOUNT_BANNER)
}